/**
 * Select
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useRef, useState, useEffect } from 'react';
import { useFieldValidation } from '../hooks/useFieldValidation';
import { useFormValue } from '../context/Form.context';
import SelectBase from './Select.base';
var Select = function (props) {
    var id = props.id, name = props.name, options = props.options, placeholder = props.placeholder, required = props.required, defaultValue = props.defaultValue, onFieldChange = props.onFieldChange, autoSubmit = props.autoSubmit, showError = props.showError, validationMessage = props.validationMessage, label = props.label, visibleFields = props.visibleFields, className = props.className;
    var _a = useFormValue(), invalidFields = _a[0].invalidFields, dispatch = _a[1];
    var _b = useState(defaultValue || options[0] || ''), value = _b[0], setValue = _b[1];
    var _c = useState(false), valid = _c[0], setValid = _c[1];
    var _d = useState(false), touched = _d[0], setTouched = _d[1];
    var fieldRef = useRef(null);
    var _e = useFieldValidation(fieldRef, __assign({ type: 'select' }, props)), validateField = _e[0], showFieldError = _e[1], hideFieldError = _e[2];
    useEffect(function () {
        var validatedField = validateField(value);
        if (validatedField.message) {
            setValid(false);
            dispatch({ type: 'FIELD_INVALID', field: validatedField });
        }
        else {
            setValid(true);
            if (invalidFields.includes(validatedField.id)) {
                dispatch({ type: 'FIELD_VALID', field: validatedField });
            }
        }
        if (touched && !valid) {
            showFieldError(validatedField);
        }
        else if ((showError && !valid && visibleFields && visibleFields.includes(id)) ||
            (showError && !valid && !visibleFields)) {
            setTouched(true);
            showFieldError(validatedField);
        }
        else {
            hideFieldError();
        }
    }, [touched, showError, value, invalidFields, visibleFields]);
    var onChange = function (e) {
        var target = e.target;
        var selectedOption = target.options[target.selectedIndex];
        var newValue = selectedOption.value || selectedOption.caption;
        if (selectedOption.id === "select-" + id + "-placeholder") {
            newValue = '';
        }
        setValue(newValue);
        onFieldChange({
            name: name,
            value: newValue,
            type: 'Select',
            autoSubmit: autoSubmit,
        });
    };
    return (React.createElement(SelectBase, { id: id, name: name, ariaInvalid: !valid && touched, defaultValue: defaultValue, required: required, onChange: onChange, onBlur: function () { return setTouched(true); }, fieldRef: fieldRef, className: className, "aria-describedby": "form" + id + "__desc" },
        placeholder && (React.createElement("option", { value: "", id: "select-" + id + "-placeholder", selected: !defaultValue && true, className: "text-greyDarker" }, placeholder)),
        options.map(function (_a) {
            var value = _a.value, caption = _a.caption;
            return (React.createElement("option", { value: value, key: value }, caption));
        })));
};
export default Select;
